module.exports = __webpack_public_path__ + "img/calendar-green.932ce37f.svg";